module.exports = __webpack_public_path__ + "aetos-ai/static/img/warning.3bf8149.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/warning.svg
// module id = OqjP
// module chunks = 13